import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import { articles, categories } from "@/mocks/articles";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  const categoryImages: Record<string, string> = {
    "wanghong-dasai": "https://readdy.ai/api/search-image?query=dramatic%20Chinese%20internet%20celebrity%20livestreaming%20competition%20stage%20with%20red%20and%20gold%20spotlights%2C%20dynamic%20crowd%20reaction%2C%20entertainment%20show%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20vibrant%20tones%2C%20modern%20TV%20studio%20setting%2C%20high%20energy%20competition%20vibe&width=1920&height=800&seq=cat-hero-dasai&orientation=landscape",
    "mingxing-bagua": "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20red%20carpet%20event%20with%20flashing%20cameras%20and%20glamorous%20atmosphere%2C%20warm%20golden%20and%20crimson%20lighting%2C%20luxury%20entertainment%20scene%2C%20editorial%20photography%20style%2C%20wide%20cinematic%20shot%2C%20elegant%20and%20dramatic&width=1920&height=800&seq=cat-hero-bagua&orientation=landscape",
    "heiliaozhuizong": "https://readdy.ai/api/search-image?query=dark%20investigative%20journalism%20scene%20with%20documents%20and%20spotlight%2C%20noir%20aesthetic%20with%20warm%20crimson%20accents%2C%20mysterious%20atmosphere%2C%20cinematic%20wide%20shot%2C%20deep%20shadows%20with%20dramatic%20highlights%2C%20truth%20seeking%20theme&width=1920&height=800&seq=cat-hero-heiliao&orientation=landscape",
    "chigua-shipin": "https://readdy.ai/api/search-image?query=colorful%20social%20media%20video%20wall%20with%20multiple%20screens%2C%20dramatic%20split%20screen%20composition%2C%20warm%20red%20and%20teal%20accents%2C%20modern%20digital%20culture%20aesthetic%2C%20entertainment%20media%20collage%2C%20cinematic%20wide%20shot&width=1920&height=800&seq=cat-hero-chigua&orientation=landscape",
  };

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-900">分类未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 font-label cursor-pointer">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const colorClasses: Record<string, string> = {
    primary: "bg-primary-500",
    accent: "bg-accent-500",
    secondary: "bg-secondary-500",
  };

  return (
    <>
      <SEOHead
        title={`${category.name} - 51爆料`}
        description={category.description}
        keywords={`51爆料,${category.name},吃瓜,八卦,黑料,网红`}
        canonicalUrl={`/category/${slug}`}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - 51爆料`,
          url: `https://www.51baoliao.com/category/${slug}`,
          description: category.description,
          isPartOf: {
            "@type": "WebSite",
            name: "51爆料",
            url: "https://www.51baoliao.com",
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { "@type": "ListItem", position: 1, item: { "@id": "https://www.51baoliao.com", name: "首页" } },
            { "@type": "ListItem", position: 2, item: { "@id": `https://www.51baoliao.com/category/${slug}`, name: category.name } },
          ],
        }}
      />

      <main>
        <Navbar />

        <section className="relative w-full h-[280px] md:h-[380px] overflow-hidden">
          <img
            src={categoryImages[slug] || categoryImages["wanghong-dasai"]}
            alt={category.name}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading font-black text-background-50 tracking-tight text-center">
              {category.name}
            </h1>
            <p className="mt-2 md:mt-3 text-base md:text-lg font-heading italic text-background-50/80 text-center">
              专区
            </p>
            <p className="mt-3 text-sm text-background-50/60 max-w-xl text-center">
              {category.description}
            </p>
            <Link
              to="/"
              className="mt-5 px-6 py-2.5 bg-background-50 text-primary-600 font-label text-sm rounded-full whitespace-nowrap hover:bg-primary-50 transition-all cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </section>

        <section className="bg-foreground-950 pt-8 md:pt-12 pb-4">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm font-label rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    slug === cat.slug
                      ? "bg-primary-500 text-background-50"
                      : "bg-foreground-800 text-foreground-300 hover:bg-foreground-700 hover:text-background-50"
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-foreground-950 pb-10 md:pb-16">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-8">
              <span className={`w-10 h-10 flex items-center justify-center rounded-full text-background-50 ${colorClasses[category.color] || colorClasses.primary}`}>
                <i className={`${category.icon} text-lg`}></i>
              </span>
              <div>
                <Breadcrumb items={[{ label: category.name }]} />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {categoryArticles.length > 0 ? categoryArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group cursor-pointer"
                >
                  <article className="bg-background-50 rounded-lg overflow-hidden transition-transform duration-300 group-hover:-translate-y-1">
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-label font-medium text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                        {article.title}
                      </h3>
                      <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.viewCount >= 10000
                            ? `${(article.viewCount / 10000).toFixed(1)}万`
                            : article.viewCount}
                        </span>
                        <span>{article.publishDate}</span>
                      </div>
                    </div>
                  </article>
                </Link>
              )) : (
                <div className="col-span-full text-center py-16">
                  <p className="text-background-50/60 text-sm">该分类暂无内容，敬请期待</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}